import React from 'react';
import LoginViewBase, { LoginViewBaseProps } from '../Login/LoginViewBase';
import { PromotionalIframeProps } from '../PromotionalIframe';
import MfaForm, { MfaFormProps } from './MfaForm';

export type MfaViewProps = LoginViewBaseProps & MfaFormProps & PromotionalIframeProps;

const MfaView = (props: MfaViewProps) => {
    const { releaseNotesUrl, promotionalIframeUrl } = props;

    return (
        <LoginViewBase releaseNotesUrl={releaseNotesUrl} promotionalIframeUrl={promotionalIframeUrl}>
            <MfaForm {...props} />
        </LoginViewBase>
    );
};

export default MfaView;
